// ** Type Import
import type { OwnerStateThemeType } from '.';
import { alpha } from '@mui/material/styles';

const inputBaseRootBackground =
  'linear-gradient(90deg, rgba(225,255,255,0.02) 0%, rgba(255,255,255,0.06) 100%)';

const filledInputRootBackground =
  'linear-gradient(90deg, rgba(225,255,255,0.05) 0%, rgba(255,255,255,0.09) 100%)';

const input = () => {
  return {
    MuiInputBase: {
      styleOverrides: {
        root: {
          background: inputBaseRootBackground,
        },
      },
    },
    // DatePicker / TimePicker use PickersTextField (not TextField), so mirror InputBase styles.
    MuiPickersInputBase: {
      styleOverrides: {
        root: {
          background: inputBaseRootBackground,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({
          background: filledInputRootBackground,
          borderTopLeftRadius: '12px',
          borderTopRightRadius: '12px',
          '&::before': {
            borderBottomColor: alpha(theme.palette.customColors.main, 0.22),
          },
          '&.Mui-focused': {
            backgroundColor: 'transparent',
          },
          '&:hover:not(.Mui-disabled):not(.Mui-error)': {
            backgroundColor: 'transparent',
            '&::before': {
              borderBottomColor: alpha(theme.palette.customColors.main, 0.32),
            },
          },
        }),
      },
    },
    MuiPickersFilledInput: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({
          background: filledInputRootBackground,
          borderTopLeftRadius: '12px',
          borderTopRightRadius: '12px',
          '&::before': {
            borderBottomColor: alpha(theme.palette.customColors.main, 0.22),
          },
          '&.MuiPickersInputBase-focused': {
            backgroundColor: 'transparent',
          },
          '&:hover:not(.MuiPickersInputBase-disabled):not(.MuiPickersInputBase-error)': {
            backgroundColor: 'transparent',
            '&::before': {
              borderBottomColor: alpha(theme.palette.customColors.main, 0.32),
            },
          },
        }),
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({
          '&:hover:not(.Mui-focused):not(.Mui-disabled):not(.Mui-error) .MuiOutlinedInput-notchedOutline':
            {
              borderColor: alpha(theme.palette.customColors.main, 0.32),
            },
          '&:hover.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.error.main,
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: alpha(theme.palette.customColors.main, 0.22),
          },
          '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.text.disabled,
          },
        }),
        multiline: () => ({ padding: '0 !important' }),
        input: () => ({
          padding: `14px 16px`,
          '.MuiDataGrid-cell &': {
            paddingLeft: '9px',
            fontSize: '14px',
          },
        }),
      },
    },
    MuiPickersOutlinedInput: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({
          '&:hover:not(.MuiPickersInputBase-focused):not(.MuiPickersInputBase-disabled):not(.MuiPickersInputBase-error) .MuiPickersOutlinedInput-notchedOutline':
            {
              borderColor: alpha(theme.palette.customColors.main, 0.32),
            },
          '&:hover.MuiPickersInputBase-error .MuiPickersOutlinedInput-notchedOutline': {
            borderColor: theme.palette.error.main,
          },
          '& .MuiPickersOutlinedInput-notchedOutline': {
            borderColor: alpha(theme.palette.customColors.main, 0.22),
          },
          '&.MuiPickersInputBase-disabled .MuiPickersOutlinedInput-notchedOutline': {
            borderColor: theme.palette.text.disabled,
          },
        }),
        sectionsContainer: {
          padding: '14px 0',
        },
      },
    },
  };
};

export default input;
